import type {
  ValidationIssue,
  ValidationResult
} from 'v5/core/entity-values/values.types';

export const validation = {
  valid(): ValidationResult {
    return { type: 'valid' };
  },
  invalid(issue: ValidationIssue): ValidationResult {
    return { type: 'invalid', issue };
  },
  required(): ValidationResult {
    return { type: 'invalid', issue: { code: 'required' } };
  }
};

/**
 * Shared `validate` skeleton: a required field with an empty value fails
 * first; otherwise the kind-specific check decides.
 */
export function validateField<V, S extends { required: boolean }>(
  value: V,
  spec: S,
  isEmpty: (value: V, spec: S) => boolean,
  check: (value: V, spec: S) => ValidationResult
): ValidationResult {
  if (spec.required && isEmpty(value, spec)) {
    return validation.required();
  }
  return check(value, spec);
}

/** Postgres `integer` bounds (`custom_fields.integer_value`). */
export const INT4_RANGE = { min: -2_147_483_648, max: 2_147_483_647 } as const;
